import { Box, Button, Card, CardContent, Container, Divider, Grid, Paper, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { UpdatePersonalAddress } from './UpdatePersonalAddress';
import { UpdateInfo } from './UpdateInfo';
import { optionProfile } from '../../constant/Constants';
import MoreInfo from './MoreInfo';
import { UpdateCardAddress } from './UpdateCardAddress';
import UpdateIcon from '@mui/icons-material/Update';
import PersonIcon from '@mui/icons-material/Person';
import { closeLoadingApi, openLoadingApi } from '../../redux/create-actions/LoadingAction';
import Color from '../../layouts/Color';
import FontSize from '../../layouts/FontSize';
import { graphGetProfile } from '../../services/Profile';

const paperStyle = { my: { xs: 1, md: 2 }, p: { xs: 1, md: 3 }, minHeight: '100%' };
const boxStyle = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column'
};
const buttonStyle = {
  cursor: 'default',
  fontSize: FontSize.Big,
  color: Color.Main,
  '&:hover': {
    background: Color.Button, color: Color.Dangerous
  }
};
const marginTopStyle = { mb: 2 };
const titleStyle = { mt: 1 };
const buttonUpdate = {
  mt: 2,
  color: Color.Button,
  backgroundColor: Color.Dangerous,
  '&:hover': { background: Color.Button, color: Color.Dangerous }
};
const container = { justifyContent: ' center' };

const ProfileMain = () => {
  const theme = useTheme();
  const [type, setType] = useState("");
  const [profiles, setProfiles] = useState(null);
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));

  const dispatch = useDispatch()

  useEffect(() => {

    dispatch(openLoadingApi());
    let promise = graphGetProfile();
    promise.then((result) => {
      setProfiles(result)
      dispatch(closeLoadingApi());
    }).catch(error => {
      const err = JSON.parse(JSON.stringify(error))
      console.log(err);
      dispatch(closeLoadingApi());
    })
  }, [dispatch])

  const resolveClick = option => {
    setType(option);
  }

  const ShowOrHide = () => {
    if (type === optionProfile.INFO) {
      return (
        <UpdateInfo update={resolveClick} profiles={profiles} />
      )
    }
    else if (type === optionProfile.PERSONAL_ADDRESS) {
      return (
        <UpdatePersonalAddress update={resolveClick} profiles={profiles} />
      )
    }
    else if (type === optionProfile.CARD_ADDRESS) {
      return (
        <UpdateCardAddress update={resolveClick} profiles={profiles} />
      )
    }
    else {
      return (
        <MoreInfo profiles={profiles} />
      )
    }
  }

  return profiles !== null ? (
    <Paper variant="outlined" sx={paperStyle}>
      <Grid container alignItems="stretch" spacing={3}>
        <Grid item lg={6} md={6} xs={12}>
          <Card >
            <CardContent>
              <Box
                sx={boxStyle}
              >
                <Button
                  sx={buttonStyle}
                  endIcon={<PersonIcon />}>
                  Profile
                </Button>
              </Box>
            </CardContent>
            <Divider sx={marginTopStyle}></Divider>
            <Box sx={marginTopStyle}>
              <Typography gutterBottom variant="h3" sx={marginTopStyle}>
                {profiles.customerName}  </Typography>
              <Typography
                variant="subtitle1"
                sx={titleStyle}
              >
                {profiles.phoneNumber}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={titleStyle}
              >
                {profiles.email}
              </Typography>
              <Button variant="contained" endIcon={<UpdateIcon fontSize="small"></UpdateIcon>} sx={buttonUpdate} onClick={() => resolveClick(optionProfile.INFO)}>
                Update
              </Button>
            </Box>
            <Grid container spacing={3} sx={marginTopStyle} alignItems="center" justifyContent="center" direction="column">
              <Grid item xs={12} sm={4} sx={container}>
                <Card sx={{ width: matchDownMD ? 250 : 350 }} variant="outlined" >
                  <CardContent>
                    <Typography variant="h4">
                      Base Address
                    </Typography>
                    <Typography variant="subtitle1">
                      {profiles.baseAddress}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid container item xs={12} sm={4} sx={container}>
                <Card sx={{ width: matchDownMD ? 250 : 350 }} variant="outlined">
                  <CardContent>
                    <Typography variant="h4">
                      Card Address
                    </Typography>
                    <Typography variant="subtitle1">
                      {profiles.cardAddress}
                    </Typography>
                    <Button variant="contained" endIcon={<UpdateIcon fontSize="small"></UpdateIcon>} sx={buttonUpdate} onClick={() => resolveClick(optionProfile.CARD_ADDRESS)}>
                      Update </Button>
                  </CardContent>
                </Card>
              </Grid>
              <Grid container item xs={12} sm={4} sx={container}>
                <Card sx={{ width: matchDownMD ? 250 : 350 }} variant="outlined">
                  <CardContent>
                    <Typography variant="h4">
                      Personal Address
                    </Typography>
                    <Typography variant="subtitle1">
                      {profiles.perAddress}
                    </Typography>
                    <Button variant="contained" endIcon={<UpdateIcon fontSize="small"></UpdateIcon>} sx={buttonUpdate} onClick={() => resolveClick(optionProfile.PERSONAL_ADDRESS)}>
                      Update </Button>
                  </CardContent>
                </Card>
                <Divider />
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item lg={6} md={6} xs={12}>
          <ShowOrHide />
        </Grid>
      </Grid>
    </Paper>
  ) : (<Container maxWidth="lg"></Container>)
}

export default ProfileMain;
